<template>
  <v-card >
    <v-card-text>
      <v-container fluid>
        <v-row dense>  
          <v-col cols="12" xl="9">
            <v-simple-table dense class="mt-1">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="3%">LIV.</th>
                    <th class="text-left" width="3%">TIPO</th>
                    <th class="text-left" width="15%">CODICE</th>
                    <th class="text-left" width="25%">DESCRIZIONE</th>
                    <th class="text-left" width="16%">LOTTO</th>
                    <th class="text-left" width="4%">UM</th>
                    <th class="text-right" width="15%">VALORE TEORICO</th>
                    <th class="text-right" width="15%">VALORE OTTENUTO</th>
                    <th class="text-right" width="4%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in distinta" :key="index" :class="{ semilavorato: item.semilavorato, manuale: item.manuale }" @click="onClickRow(item, $event)">
                    <td class="text-left pl-2">{{ item.livello }}</td>
                    <td class="text-left"><v-icon :title="titoloIcona(item)">{{ icona(item) }}</v-icon></td>
                    <td class="text-left" v-if="item.tipo !== 'nota'">{{ item.codice }}</td>
                    <td class="text-left" v-if="item.tipo !== 'nota'">{{ item.descrizione }}</td>
                    <td class="text-left" v-else colspan="2">{{ item.descrizione }}</td>
                    <td class="text-left" v-if="item.lotto">{{ item.lotto && item.lotto.id }}</td>
                    <td class="text-left" v-else-if="item.tipo === 'prodotto' && !item.semilavorato">- - -</td>
                    <td v-else></td>
                    <td class="text-left">{{ item.unitaMisura }}</td>
                    <td class="text-right">{{ item.quantita || item.valore || '' }}</td>
                    <td class="text-right pr-3" v-if="usaQuantitaTeorica || item.semilavorato || item.tipo === 'nota'">
                      {{ item.usato || item.valoreUsato || '' }}
                    </td>
                    <td class="text-right pr-3" v-else-if="item.tipo === 'prodotto'" :class="{ 'usato-diverso-quantita': (item.quantita !== item.usato) }">
                      <v-text-field v-model="item.usato" data-campo="usato" dense flat solo hide-details="auto" :readonly="item.semilavorato" :placeholder="String(item.quantita)" :rules="[numerico]" reverse :background-color="'transparent'" @change="onChangeUsato(item, true)"/>
                    </td>
                    <td class="text-right pr-3" v-else-if="item.tipo === 'multiselect'">
                      <v-select v-model="item.valoreUsato" dense flat solo hide-details="auto" :items="item.valori" item-text="valore" item.value="valore" @change="onChangeUsato(item)" reverse></v-select>
                    </td>
                    <td class="text-right pr-3" v-else>
                      <v-text-field v-model="item.valoreUsato" dense flat solo hide-details="auto" :readonly="item.semilavorato" :placeholder="String(item.valore || '')" reverse @change="onChangeUsato(item)"/>
                    </td>
                    <td class="text-right"><v-btn v-if="item.semilavorato && aggiuntaProdottoAbilitata" icon @click.stop="onNuovoProdotto(item, index)" title="Aggiungi un prodotto"><v-icon>mdi-plus-circle-outline</v-icon></v-btn></td>
                  </tr>
                </tbody>                
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-dialog v-model="dialogProdotto" max-width="700px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Inserimento prodotto</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="9">
                    <component :is="'pProdotto'" :item="itemCodice(editedItem)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :solo="false" :suTable="true" :isLotto="true" :isProdottoBase="true" :clearInfo="clearInfo" :popolaInfo="popolaInfo"/>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-text-field v-model="editedItem.quantita" label="Quantità Teorica" flat dense :rules="[numerico]" @change="onChangeQuantita" reverse></v-text-field>
                  </v-col>                  
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.descrizione" label="Descrizione"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <!-- <component :is="'pLotto'" :item="itemLotto(item)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :codiceProdotto="editedItem.codice" :solo="false" :suTable="true" :clearInfo="clearInfo"/> -->
                    <v-autocomplete
                      v-model="editedItem.lotto"
                      :items="lottiProdotto"
                      label="Lotti prodotto"
                      item-text="testo"
                      item-value="id"
                      clearable
                      dense
                      hide-details="auto"
                      :flat="true"
                      :return-object="true"
                    >
                      <template v-slot:selection="{ item }">
                        <span>{{ item.testo }}</span>
                      </template>  
                    </v-autocomplete>
                  </v-col>                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialogProdotto">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="saveDialogProdotto">Salva</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>  
        <v-dialog v-model="dialogLotto" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Inserimento lotto per prodotto</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>             
                  <v-col cols="12" sm="12" md="12">
                    <!-- Elenco dei lotti: filtro per Codice === _id prodotto base e !lotti.ProdottoBase -->
                    <!-- <component :is="'pLotto'" :item="itemLotto(item)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :codiceProdotto="editedItem.codice" :solo="false" :suTable="true" :clearInfo="clearInfo"/> -->
                    <v-autocomplete
                      v-model="editedItem.lotto"
                      :items="lottiProdotto"
                      label="Lotti prodotto"
                      item-text="testo"
                      item-value="id"
                      clearable
                      dense
                      hide-details="auto"
                      :flat="true"
                      :return-object="true"
                    >
                      <template v-slot:selection="{ item }">
                        <span>{{ item.testo }}</span>
                      </template>                    
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialogLotto">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="saveDialogLotto">Salva</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>              
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import { ordinaLotti } from '@/components/helpers'
  import prodotti from '@/services/prodottiService.js'
  import documenti from '@/services/documentiService.js'
  import pProdotto from './elementi/prodotto'

  export default {
    components: {
      pProdotto
    },
    props: {
      locLotto: Object,
      item: Object,
      usaQuantitaTeorica: { type: Boolean, default: true },
      updateTrigger: Number
    },
    data () {
      return {
        // usaQtaTeorica: true,
        distinta: [],
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        aggiuntaProdottoAbilitata: true, // TODO: Passare da impostazioni
        dialogLotto: false,
        dialogProdotto: false,
        editedIndex: -1,
        editedItem: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          lotto: '',
          unitaMisura: '',
          quantita: 1,
          livello: 0
        },
        defaultItem: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          lotto: '',
          unitaMisura: '',
          quantita: 1,
          livello: 0
        },
        trigger: 1,
        clearInfo: 1,
        popolaInfo: 1,
        lottiProdotto: []
      }
    },
    async mounted() {
      if (this.item) {
        if (this.item.distinta) {
          this.distinta = this.item.distinta
        } else {
          await this.caricaDistinta(this.item.quantita)
        }
      }
      const qtaEffettiva = _.get(this, 'item.totUsato', 0) || _.get(this, 'item.quantita', 0)
      const totUsato = _.get(this, 'item.totUsato', 0) || 0
      const qtaRimasta = qtaEffettiva - totUsato
      this.$emit('changeUsato', { qtaEffettiva, totUsato, qtaRimasta })      
    },
    watch: {
      async item(value) {
        await this.elaboraDistinta(value.quantita)
      },
      async updateTrigger() {
        await this.elaboraDistinta(this.item.quantita)
      },
      async usaQuantitaTeorica(value) {
        if (value) {
          await this.caricaDistinta(this.item.quantita)
        }
      },      
      distinta(value) {
        if (value) {
          console.log('change distinta')
          this.$emit('distinta', value)
        }
      }
    },
    methods: {
      infoLotto(item) {
        return `${item.testo} - sc:${item.scadenza} - qta:${item.giacenza}`
      },
      icona(item) {
        switch(item.tipo) {
          case 'nota':
            return 'mdi-note-outline'
          case 'parametro':
            return 'mdi-cog-outline'
          case 'multiselect':
            return 'mdi-selection-multiple'
          default:
            if (item.manuale) {
              return 'mdi-hand-back-left-outline'
            }
            return ''
        }
      },
      titoloIcona(item) {
        switch(item.tipo) {
          case 'nota':
            return 'Nota'
          case 'parametro':
            return 'Parametro'
          case 'multiselect':
            return 'Selezione multipla'
          default:
            if (item.manuale) {
              return 'Inserimento manuale'
            }
            return ''
        }
      },
      onClickRow(item, event) {
        if (event.target.attributes['data-campo']) {
          return
        }
        if (item.manuale) {
          this.onEditProdotto(item)
        } else {
          if (item.richiedeLotto) {
            this.onEditLotto(item)
          }
        }
      },
      onEditProdotto(item) {
        if (item.manuale) {
          this.editItemProdotto(item)
        }
      },
      editItemProdotto (item) {
        this.editedIndex = this.distinta.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.popolaInfo++
        this.dialogProdotto = true
      },
      closeDialogProdotto() {
        this.dialogProdotto = false
        this.$nextTick(() => {
          this.clearInfo++
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },      
      saveDialogProdotto() {
        if (this.editedIndex > -1) {
          Object.assign(this.distinta[this.editedIndex], this.editedItem)
        } else {
          this.distinta.push(this.editedItem)
        }
        this.closeDialogProdotto()
      },
      async onEditLotto(item) {
        if (item.tipo === 'prodotto' && !item.semilavorato) {
          await this.popolaLottiProdotto(item.codice)
          this.editItemLotto(item)
        }
      },
      editItemLotto (item) {
        this.editedIndex = this.distinta.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogLotto = true
      },      
      closeDialogLotto() {
        this.dialogLotto = false
        this.$nextTick(() => {
          this.clearInfo++
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      saveDialogLotto() {
        if (this.editedIndex > -1) {
          Object.assign(this.distinta[this.editedIndex], this.editedItem)
        } else {
          this.distinta.push(this.editedItem)
        }
        this.closeDialogLotto()
      },
      async onNuovoProdotto(item, index) {
        let newItem = JSON.parse(JSON.stringify(this.defaultItem))
        newItem.livello = item.livello + 1
        newItem.quantita = ''
        newItem.usato = 0
        newItem.manuale = true
        newItem.tipo = 'prodotto'
        //const insertionPosition = index + 2
        let el = this.distinta.indexOf(item)
        
        let childs = 0
        while (++el < this.distinta.length) {
          const dd = this.distinta[el]
          if (!dd.semilavorato) {
            childs++
          } else {
            break
          }
        }
        
        const insertionPosition = index + childs + 1
        const list1 = this.distinta.splice(0, insertionPosition)
        const list2 = this.distinta
        this.distinta = [...list1, newItem, ...list2]
      },
      onChangeQuantita() {
        this.editedItem.quantita = +parseFloat(this.editedItem.quantita).toFixed(2)
        this.editedItem.usato = this.editedItem.quantita 
      },
      onChangeQtaTeorica() {
        for (let el of this.distinta) {
          el.usato = el.quantita
        }
        this.$emit('distinta', this.distinta)
      },
      onChangeUsato(item, isQuantita) {
        if (isQuantita) {
          item.usato = parseFloat(item.usato || 0)
          const totUsato = _.sumBy(this.distinta.filter(x => x.livello !== 0), 'usato')
          const qtaEffettiva = _.sumBy(this.distinta.filter(x => x.livello === 0), 'usato')
          const qtaRimasta = qtaEffettiva - totUsato
          if (qtaRimasta < 0) {
            alert("Attenzione la quantità utilizzata è maggiore di quella disponibile!")
            item.usato = 0
          } else {
            this.$emit('changeUsato', { qtaEffettiva, totUsato, qtaRimasta })
          }
        }
        this.$emit('distinta', this.distinta)
      },
      async elaboraDistinta(qta) {
        // legge in base al prodotto selezionato
/*         const distinta = require('./distinta.json')
        const elenco = this.elaboraItem(distinta, qta, 0)
        this.distinta = elenco */
      },
      async caricaDistinta(qta) {
        // legge in base al prodotto selezionato
        // const distinta = require('./distinta.json')
        // const prodotto = await prodotti.getProdotto(this.item.prodotto.codice)
        const prodotto = await prodotti.getProdotto(this.item.base)
        const itmDistinta = _.get(prodotto, 'bom.gestione.distinta')
        if (itmDistinta) {
          const codice = itmDistinta.codice
          const doc = await documenti.getDocumento(codice)
          const distinta = doc.distinta
          const elenco = this.elaboraItem(distinta, qta, 0)
          console.log('caricadistinta', this.distinta, elenco)
          this.distinta = elenco
        } else {
          this.distinta = []
        }
      },
      elaboraItem(item, qta = 1, livello) {
        let elenco = []
        if (item.items) {
          elenco.push({ livello: livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione, quantita: +(qta * item.quantita).toFixed(2), valore: item.valore, lotto: '---', semilavorato: true, usato: +(qta * item.quantita).toFixed(2), unitaMisura: item.unitaMisura })
          for (let i of item.items) {
            const totQta = qta * item.quantita
            elenco = elenco.concat(this.elaboraItem(i, totQta, livello + 1))
          }
        } else {
          let valori = item.valori || []
/*           if (item.elencoValori) {
            valori = item.elencoValori.map(x => {
              return { valore: x }
            })
          } */       
          elenco.push({ livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione, quantita: +(qta * item.quantita).toFixed(2), valore: item.valore, valoreUsato: item.valore, lotto: item.lotto, semilavorato: false, usato: +(qta * item.quantita).toFixed(2), unitaMisura: item.unitaMisura, valori: valori })
        }
        return elenco
      },
      itemCodice(item) {
        // console.log('itemcodice', item.codice)
        return {
          "model": "codice",
          "valueField": "codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (item && item.codice) || ''
        }
      },
      itemLotto(item) {
        return {
          "model": "lotto",
          "valueField": "lotto",
          "label": "Lotto Prodotto",
          "type": "Lotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (item && item.lotto) || ''
        }
      },
      async componentValueChange(data) {
        // console.log('componentValueChange', data.model)
        const { model, subModel, value, decimals, index } = data
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.editedItem, tgt)
        await this.aggiornaCorrelati(data)
      },
      async aggiornaCorrelati(data) {
        switch (data.model) {
          case 'codice':
            this.editedItem.descrizione = _.get(data, 'item.descrizione', '')
            this.editedItem.unitaMisura = _.get(data, 'item.item.magazzino.unitaMisura', '')
            this.trigger++
            await this.popolaLottiProdotto(data.value)
            // this.elaboraDistinta()
            break
          default:
            break
        }
      },
      changeQuantita(value) {
        const qta = parseFloat(value)
        this.elaboraDistinta(qta)
      },
      async popolaLottiProdotto(codiceProdotto, quantita) {
        const filtri = {
          codice: codiceProdotto,
          isLotto: true,
          isLottoBase: false
        }
        const opzioni =  {
          itemsPerPage: -1
        }
        const data = await prodotti.getFilteredProducts(filtri, opzioni)
        const cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
        //TODO: I lotti vanno ordinati seocndo la gestione che è stata impostata (FIFO, FEFO, etc.)
        const gestione = _.get(this.item,'appoggio.prodotto.item.lotti.gestione.criterioConsumoScarico.codice', '')
        this.lottiProdotto = ordinaLotti(cp, gestione, quantita).map(x => {
          return {
            id: x.lotti.lotto,
            testo: x.lotti.lotto,
            testo: `${x.lotti.lotto} - sc:${x.lotti.scadenza || '---'} - qta:${x.magazzino.giacenza}`,
            codiceProdotto: x._id,
            giacenza: x.magazzino.giacenza, // TODO: Verificare per giacenza multipla
            scadenza: x.lotti.scadenza || '---' // TODO: Più eventuali altre date
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-input {
    font-size: 14px;
  }
  .semilavorato {
    background-color: rgb(222, 228, 233);
  }
  .manuale {
    background-color: rgb(193, 241, 183);
  }
  .usato-diverso-quantita {
    color: '#EF5350';
  }
</style>
